module.exports = __webpack_public_path__ + "img/parts-service-stock-image.56e20056.jpeg";